import {
    LaneFeesStatus,
} from 'app/enums/label.enums'
import {
    LaneFeesActionButtons, LaneFeesUpdate,
} from 'app/shared-components/LaneFees'

export default function AssignPricingLaneFeesUpdate({
    id,
    refetch,
}: Readonly<{ id?: number, refetch?: (...args: any[]) => void }>) {
    return (
        <LaneFeesUpdate
            id={id}
            refetch={refetch}
            buttonsConfig={{
                [LaneFeesStatus.SUBMITTED]: [
                    LaneFeesActionButtons.Copy,
                    LaneFeesActionButtons.SetInProgress,
                    LaneFeesActionButtons.SetToCancelled,
                    LaneFeesActionButtons.ChangeValidity,
                ],
                [LaneFeesStatus.IN_PROGRESS]: [
                    LaneFeesActionButtons.Copy,
                    LaneFeesActionButtons.SetAsSubmitted,
                    LaneFeesActionButtons.SetToCancelled,
                ],
                [LaneFeesStatus.REJECTED]: [
                    LaneFeesActionButtons.Copy,
                    LaneFeesActionButtons.SetToCancelled,
                ],
                [LaneFeesStatus.CANCELLED]: [
                    LaneFeesActionButtons.Copy,
                    LaneFeesActionButtons.Archive,
                ],
                [LaneFeesStatus.AWARDED]: [
                    LaneFeesActionButtons.Copy,
                    LaneFeesActionButtons.SetToCancelled,
                    LaneFeesActionButtons.ChangeValidity,
                ],
            } as Record<LaneFeesStatus, LaneFeesActionButtons[]>}
        />
    )
}
